import { formatDateYYYYMMDD } from '../../../../common/dateUtils'

export const PREP_PDF_STYLES = `
      .prep-container {
        height: auto !important;
        max-width: 640px !important;
      }
      
      .border {
        border: none !important;
      }
    `

export const buildMeetingPrepFileName = (base: string, startedAt: string | undefined, title: string | undefined, typeName: string | undefined): string => {
  const dateSuffix = startedAt ? `_${formatDateYYYYMMDD(startedAt)}` : ''
  const rawLabel = (title?.trim() && title.trim() !== 'Untitled Meeting' ? title.trim() : typeName?.trim()) ?? ''
  const safeLabel = rawLabel
    .replace(/[\\/:*?"<>|]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
  const namePrefix = safeLabel ? ` - ${safeLabel}` : ''
  return `${base}${namePrefix}${dateSuffix}.pdf`
}
